import React from 'react';
import { Icon } from '@web-chat-core/ui-kit';
import { KeypadButton } from './view';

interface SIPKeypadButtonProps {
    onClick: () => void;
}

export const SIPKeypadButton: React.FC<SIPKeypadButtonProps> = ({ onClick }) => {
    return (
        <KeypadButton onClick={onClick}>
            <Icon icon="icKeypad" colorVariant="basic" />
        </KeypadButton>
    );
};
